<div class="modal-body">
    <cm-dynamic-form-content-details [contentDetails]="modalDetails"></cm-dynamic-form-content-details>
    <cm-dynamic-form
        #testRegForm
        [isZeroValueAllowed]="true"
        [elements]="isStepSubmitted ? step.content.forms[0].fields : formInfo?.fields"
        [disabled]="isStepSubmitted"
        [showErrors]="showErrors"
        [sections]="step.content.sections"
        (updateFieldValue)="updateFieldValue($event)"
        class="form"
    ></cm-dynamic-form>
    <div class="signature-container">
        <cm-signature
            #stepSignature
            *ngIf="formInfo?.signature_required || (isStepSubmitted && signatureLink)"
            class="signature-bar"
            [class.signature-bar--full]="!isStepSubmitted"
            [editable]="!isStepSubmitted"
        ></cm-signature>
    </div>
    <div
        class="add-ada-option"
        *ngIf="
            step.content.useAda &&
            !isStepSubmitted &&
            !adaStep?.isStepSubmitted &&
            (!adaStep?.rejectStepData || !adaStep.rejectStepData.isRejected)
        "
    >
        <label class="info-block__label text-margin-left">
            Do you wish to request testing accommodations under the Americans with Disabilities Act (ADA) or the
            Canadian Human Rights Laws?
        </label>
        <div class="form-group-item text-margin-left">
            <cm-radio-group
                [options]="defaultOptions"
                [(ngModel)]="useAdaOption"
                (ngModelChange)="shouldApplyAda($event)"
            ></cm-radio-group>
        </div>
        <div *ngIf="useAdaOption">
            <label class="text-margin-left">
                By selecting this option, I hereby confirm my request for special accommodations under the Americans
                with Disabilities Act (ADA) or the Canadian Human Rights Laws
            </label>
            <div *ngIf="adaFormInfo?.fields">
                <cm-dynamic-form
                    #adaForm
                    [isZeroValueAllowed]="true"
                    [elements]="adaFormInfo.fields"
                    [disabled]="isStepSubmitted"
                    [showErrors]="showErrors"
                    [sections]="adaStep.content.sections"
                    class="form"
                ></cm-dynamic-form>
            </div>
        </div>
    </div>
    <div class="signature-container" *ngIf="useAdaOption && adaFormInfo?.signature_required">
        <cm-signature #adaSignature class="signature-bar--full" [editable]="!isStepSubmitted"></cm-signature>
    </div>
    <div class="form-errors" [ngClass]="{ 'show-errors': showErrors }">
        <p *ngFor="let errorText of dynamicFormErrors">{{ errorText }}</p>
    </div>
</div>
<div class="modal-footer">
    <button *ngIf="!isStepSubmitted" type="button" class="btn btn-default" (click)="dismissModal()">BACK</button>
    <button *ngIf="!isStepSubmitted" type="button" class="btn btn-primary" (click)="submitForm()">SUBMIT</button>
    <button *ngIf="isStepSubmitted" type="button" class="btn btn-primary" (click)="dismissModal()">CLOSE</button>
</div>
